import { useState, useEffect } from 'react';
import { useAuth } from '@/providers/AuthProvider';
import type { WootricUser } from '@/types/wootric';

interface UseUserProfileResult {
  user: WootricUser | null;
  isLoading: boolean;
  error: Error | null;
}

export function useUserProfile(): UseUserProfileResult {
  const { email, organisationId } = useAuth();
  const [user, setUser] = useState<WootricUser | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchUserProfile = async (): Promise<void> => {
      try {
        setIsLoading(true);

        if (!email) {
          setIsLoading(false);
          return;
        }

        setUser({
          email,
          userId: organisationId ?? '',
          createdAt: new Date(),
        });
      } catch (err) {
        setError(err instanceof Error ? err : new Error('Failed to get user profile'));
      } finally {
        setIsLoading(false);
      }
    };

    fetchUserProfile();
  }, [email, organisationId]);

  return { user, isLoading, error };
}
